document.addEventListener("DOMContentLoaded", function () {
    // Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function (element) {
        element.addEventListener('mouseover', function (e) {
            // Your existing code for dropdown
        });
    });

    // Device detection and conditional display logic
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect iOS
    var isIOS = (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;

    // Detect Android
    var isAndroid = /android/i.test(userAgent);

    if (isIOS) {
        document.getElementById('smrtConnectPlayStore').style.display = 'none';
        document.getElementById('winkPlayStore').style.display = 'none';
    } else if (isAndroid) {
        document.getElementById('smrtConnectAppStore').style.display = 'none';
        document.getElementById('winkAppStore').style.display = 'none';
    }
});
